export default function containKeyworkd(text,keyword) {
    if(keyword===''||keyword===null)return true;
    const lowerText=text.toLowerCase();
    return lowerText.includes(keyword.toLowerCase());
}